import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Account from '../components/account';
import { FestivalForm, FestivalView } from '../components/festivals';
import Home from '../components/home';
import Login from '../components/login/Login';
import { ResetPassword, RequirePasswordChange } from '../components/password';
import {
  Performers,
  PerformerFormPage,
  PerformerView,
} from '../components/performers';
import Signup from '../components/signup/Signup';
import { VendorFormPage, VendorView } from '../components/vendors';
import ProtectedRoute from './ProtectedRoute';

export default (props) => (
  <Switch>
    <Route exact path="/login" component={Login} />
    <Route exact path="/reset-password" component={ResetPassword} />
    <Route exact path="/signup" component={Signup} />
    <ProtectedRoute
      exact
      path="/change-password"
      component={RequirePasswordChange}
    />
    <ProtectedRoute exact path="/" component={Home} />
    <ProtectedRoute exact path="/account" component={Account} />
    <ProtectedRoute exact path="/festival/:id/view" component={FestivalView} />
    <ProtectedRoute path="/festival/:id" component={FestivalForm} />
    <ProtectedRoute
      exact
      path="/performer/:id/view"
      component={PerformerView}
    />
    <ProtectedRoute path="/performer/:id" component={PerformerFormPage} />
    <ProtectedRoute exact path="/vendor/:id/view" component={VendorView} />
    <ProtectedRoute path="/vendor/:id" component={VendorFormPage} />
    <ProtectedRoute path="/performers" component={Performers} />
  </Switch>
);
